exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hello[data-v-7750de2e]{position:fixed;top:50%;left:50%;margin-left:-130px;text-align:center}.hello a[data-v-7750de2e]{display:block;width:100%;height:500px;text-decoration:none;color:#464646}.hello img[data-v-7750de2e]{animation:appear-data-v-7750de2e 2s linear;width:260px}@keyframes appear-data-v-7750de2e{0%{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7750de2e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/hello.vue
// module id = 73
// module chunks = 0